module.exports = __webpack_public_path__ + "media/images/athletes/4350-b1c4d6c7cafceab8d981d41e14a6f493.png";